import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { HttpService } from '../service/http.service';
import { SiepSalonContact } from '../siep-salon-contact';

@Component({
  selector: 'app-siep-salon-contacts',
  templateUrl: './siep-salon-contacts.component.html',
  styleUrls: ['./siep-salon-contacts.component.css']
})
export class SiepSalonContactsComponent implements OnInit {

  contacts: SiepSalonContact[] = [];

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
    this.httpService.getSiepSalonContacts().subscribe(res => {
      this.contacts = res;
      for(let contact of this.contacts){
        contact.birthDate = moment(contact.birthDate);
        contact.registerDate = moment(contact.registerDate);
      }
    });
  }

}
